import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import router from './router'
import { store } from './store';
import VueFeather from 'vue-feather'
import VueCookies from 'vue-cookies'
import VCalendar from 'v-calendar'
import VueApexCharts from 'vue-apexcharts'

// Import Theme scss
import './assets/scss/app.scss'

Vue.use(VCalendar)
Vue.use(VueFeather)
Vue.use(BootstrapVue)
Vue.use(VueCookies, { expires: '1M'})
Vue.use(VueApexCharts)
Vue.use(require('vue-shortkey'))
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')